var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWesternUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFDD00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.78,366.86c26.61,45.94,70.13,45.94,96.58,0l14.79-25.65L126.22,110.83H0L147.78,366.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M427.99,268.41c-9.69,16.66-32.56,16.66-42.21,0l-91.13-157.62H168.33l148.03,256.08 c26.61,45.94,69.98,45.94,96.58,0L512,195.25l-48.77-84.57H337.01L427.99,268.41z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWesternUnion);
export default __webpack_public_path__ + "static/media/WesternUnion.327a566d2fc86bce6f63a794c44b1d10.svg";
export { ForwardRef as ReactComponent };